// extracted by mini-css-extract-plugin
export default {"container":"YL-z","topReviewHeading":"ZL-z","criticalReview":"_L-z","favorableReview":"aM-z","vsSeparator":"bM-z"};